import React from "react";
import tw from "twin.macro";

import { PrimaryButton, Link2 } from "../Components/MiscStyles/Buttons";

const Container = tw.div`relative md:mb-0 mb-80`;

const Header = tw.div`h-90 bg-secondary relative`;
const HeaderContent = tw.div`text-white absolute bottom-0  md:mx-72 mx-10   pb-10 text-4xl`;

const Content = tw.div` md:mx-72 mx-10  my-20 `;
const FlexContainer = tw.div`md:flex  items-center`;

const Section2 = tw.div` bg-gray-200`;
const WideContainer = tw.div`md:w-8/12 md:pl-72 md:pr-24 mx-10`;
const SmallContainer = tw.div`md:w-4/12`;

const Section3 = tw.div`mb-16 md:mb-0`;
const SecondWideContainer = tw.div`md:w-8/12 md:pr-72 md:pl-24 mx-10`;
const SecondSmallContainer = tw.div`md:w-4/12`;

const Heading = tw.h2`text-3xl  font-playfair`;
const HeadingMain = tw.h2`text-3xl text-center font-playfair`;
const Subheading = tw.h5`text-sm my-4 `;
const Paragraph = tw.h5`text-sm my-4 opacity-70 `;
const HeaderParagraph = tw.h5`text-smm my-2 w-3/4`;

export default () => {
    return (
        <Container>
            <Header>
                <HeaderContent>
                    <Heading>SERVICES</Heading>
                    <HeaderParagraph>
                        SEE BELOW TO HAVE A GREATER UNDERSTANDING OF WHAT SINGH DRYWALL
                        HAS TO OFFER, WHERE WE ARE GOING AND WHAT WE HOLD IMPORTANT TO US AS A
                        COMPANY
                    </HeaderParagraph>
                </HeaderContent>
            </Header>
            <Content>
                <HeadingMain>A Solution For Every Need</HeadingMain>
                <Paragraph>
                    As projects become more complex and schedules become more aggressive,
                    Construction Management arrangements have become more common.In this
                    approach, the Client and Construction Manager agree on a fee structure
                    for the Construction Manager’s costs and fee. This can be established
                    based upon fixed numbers or based upon percentages of the cost of the
                    Subcontractor/Vendor costs.
                    <br />
                    <br /> Construction Management arrangements provide less initial cost
                    certainty, but the Construction Manager acts as the client’s agent and
                    solely in the best interests of the client and project from the
                    outset.
                    <br />
                    <br /> Contractually, CJS will manage and coordinate all trades from
                    start to finish. We will hold each individual contract (same as
                    general contracting), but the client/design team will have full
                    visibility into all sub-contractor and vendor costs through the
                    bidding, buy out and award processes.
                    <br />
                    <br />
                    CJS will competitively bids all aspects of the project, which ensures
                    that we are achieving the most cost effective and responsible price
                    for each trade.
                    <br />
                    <br />
                    This approach gives significantly more visibility into all project
                    costs and offers the possibility of a shared returned savings to the
                    Client for any costs that come in under the project budget.
                </Paragraph>
            </Content>

            <Section3>
                <FlexContainer>
                    <SecondSmallContainer>
                        <img src="https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/Articles/how-to-tape-and-mud-drywall-step-4.jpg" />
                    </SecondSmallContainer>

                    <SecondWideContainer>
                        <Heading>Commercial & Industrial Painting</Heading>
                        <Paragraph>
                            We offer a long list of specialised services related to repainting commercial and industrial buildings. We apply special coating systems that are more durable than conventional paints i.e. less prone to fading, chalking and rusting
                        </Paragraph>
                        <br />
                        <PrimaryButton href="/ContactUs">GET IN TOUCH</PrimaryButton>

                        <br />
                        <br />
                        <br />
                    </SecondWideContainer>
                </FlexContainer>
            </Section3>

        </Container >
    );
};
